import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import MapMaker from './index';
import { MobileMapMaker } from './mobile';

const ResponsiveMapMaker: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  return isMobile ? <MobileMapMaker /> : <MapMaker />;
};

export default ResponsiveMapMaker;
